"use strict";
var MESSAGE_CLASS = "success";
var ERROR_MESSAGE_CLASS = "error";
var createElementMessage = function(className, message) {
    var div = document.createElement("div");
    div.className = className;
    div.textContent = message;
    div.setAttribute("data-qa", "notification");
    return div;
};
var addMessage = function(selector, text) {
    document.body.appendChild(createElementMessage(selector, text));
};
var leftClick = false;
var rightClick = false;
var firstSettled = false;
var secondResolved = false;
var thirdResolved = false;
var resolveFirstPromise;
var timeoutId;
var firstPromise = new Promise(function(resolve, reject) {
    timeoutId = setTimeout(function() {
        firstSettled = true;
        reject(new Error("First promise was rejected"));
    }, 3000);
    resolveFirstPromise = resolve;
});
firstPromise.then(function(message) {
    addMessage(MESSAGE_CLASS, message);
}).catch(function(error) {
    addMessage(ERROR_MESSAGE_CLASS, error.message);
    cleanup();
});
var resolveSecondPromise;
var secondPromise = new Promise(function(resolve) {
    resolveSecondPromise = resolve;
});
secondPromise.then(function(message) {
    addMessage(MESSAGE_CLASS, message);
}).catch(function(error) {
    addMessage(ERROR_MESSAGE_CLASS, error.message);
    cleanup();
});
var resolveThirdPromise;
var thirdPromise = new Promise(function(resolve) {
    resolveThirdPromise = resolve;
});
thirdPromise.then(function(message) {
    addMessage(MESSAGE_CLASS, message);
    cleanup();
}).catch(function(error) {
    addMessage(ERROR_MESSAGE_CLASS, error.message);
    cleanup();
});
var resolveFirst = function() {
    if (!firstSettled) {
        firstSettled = true;
        document.removeEventListener("click", handleDocumentLeftClick);
        clearTimeout(timeoutId);
        resolveFirstPromise("First promise was resolved");
    }
};
var resolveSecond = function() {
    if (!secondResolved) {
        secondResolved = true;
        resolveSecondPromise("Second promise was resolved");
    }
};
var resolveThird = function() {
    if (!thirdResolved && rightClick && leftClick) {
        thirdResolved = true;
        resolveThirdPromise("Third promise was resolved");
    }
};
var handleDocumentLeftClick = function(e) {
    if (!firstSettled && e.button === 0) {
        resolveFirst();
        resolveSecond();
        leftClick = true;
        resolveThird();
    }
};
var handleDocumentRightClick = function(e) {
    e.preventDefault();
    resolveSecond();
    rightClick = true;
    resolveThird();
};
var cleanup = function() {
    document.removeEventListener("click", handleDocumentLeftClick);
    document.removeEventListener("contextmenu", handleDocumentRightClick);
};
document.addEventListener("click", handleDocumentLeftClick);
document.addEventListener("contextmenu", handleDocumentRightClick);

//# sourceMappingURL=index.1ccfa385.js.map
